// Geometry and Trigonometry reference sheet — quick-lookup formulas and
// rules, as opposed to the instructional walkthroughs with worked examples
// in the Math domain guide. Keep entries short: a formula or rule, not a
// lesson. Paragraphs are plain strings or structured blocks
// { type: 'list', ... }.

export const documentTitle = 'Geometry and Trigonometry Reference';
export const documentSlug = 'geometry-trigonometry-reference';

export const parts = [
  {
    id: 'geometry-reference-full',
    title: null,
    sections: [
      {
        id: 'gr-area-volume',
        heading: 'Area and Volume Formulas',
        paragraphs: [
          {
            type: 'list',
            items: [
              'Rectangle: A = lw',
              'Triangle: A = ½bh',
              'Circle: A = πr², circumference = 2πr',
              'Rectangular prism: V = lwh',
              'Cylinder: V = πr²h',
            ],
          },
        ],
      },
      {
        id: 'gr-angles',
        heading: 'Angle Relationships',
        paragraphs: [
          {
            type: 'list',
            items: [
              'Vertical angles are equal.',
              'Supplementary angles sum to 180°.',
              'When a transversal crosses parallel lines, alternate interior angles are equal and same-side interior angles are supplementary.',
              "A triangle's interior angles always sum to 180°.",
            ],
          },
        ],
      },
      {
        id: 'gr-right-triangles',
        heading: 'Right Triangles',
        paragraphs: [
          {
            type: 'list',
            items: [
              'Pythagorean theorem: a² + b² = c², where c is the hypotenuse',
              '45-45-90 triangle: legs of length x, hypotenuse x√2',
              '30-60-90 triangle: short leg x, long leg x√3, hypotenuse 2x',
            ],
          },
        ],
      },
      {
        id: 'gr-trig-ratios',
        heading: 'Trigonometric Ratios (SOH-CAH-TOA)',
        paragraphs: [
          {
            type: 'list',
            items: ['sine = opposite / hypotenuse', 'cosine = adjacent / hypotenuse', 'tangent = opposite / adjacent'],
          },
        ],
      },
      {
        id: 'gr-circles',
        heading: 'Circles',
        paragraphs: [
          {
            type: 'list',
            items: [
              'Equation of a circle: (x - h)² + (y - k)² = r², center (h, k), radius r',
              'Arc length = (central angle / 360°) × 2πr',
              'Sector area = (central angle / 360°) × πr²',
              '180° = π radians',
            ],
          },
        ],
      },
    ],
  },
];
